import React, { MutableRefObject, useRef, useEffect } from 'react';
import { StyledModalWrapper } from '../Styled';
import { StyledScrollableModalWrapper } from '../Styled/StyledWrappers';

interface IScrollableModal {
  children: JSX.Element | JSX.Element[];
  onClose: () => void;
}

export const ScrollableModal: React.FC<IScrollableModal> = (props): JSX.Element => {
  const { children, onClose } = props;

  const modalRef = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      const target = event.target as HTMLElement;
      if (modalRef.current && !modalRef.current.contains(target)) {
        onClose();
      }
    };

    document.body.addEventListener('click', handleOutsideClick);
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.removeEventListener('click', handleOutsideClick);
      document.body.style.overflow = 'auto';
    };
  }, [onClose]);

  return (
    <StyledModalWrapper data-testid="scrollable-modal">
      <StyledScrollableModalWrapper ref={modalRef}>{children}</StyledScrollableModalWrapper>
    </StyledModalWrapper>
  );
};
